import Vue from 'vue'
import Router from 'vue-router'
import store from '@/components/Store'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import EventsList from '@/components/Events/List'
import EventEdit from '@/components/Events/Edit'
import EventImport from '@/components/Events/Import'
import EventDuplicate from '@/components/Events/Duplicate'
import CitiesList from '@/components/Cities/List'
import CityEdit from '@/components/Cities/Edit'
import SchoolsList from '@/components/Schools/List'
import SchoolEdit from '@/components/Schools/Edit'
import EstablishmentsList from '@/components/Establishments/List'
import EstablishmentEdit from '@/components/Establishments/Edit'
import TypesList from '@/components/Types/List'
import TypeEdit from '@/components/Types/Edit'
import LabelsList from '@/components/Labels/List'
import LabelEdit from '@/components/Labels/Edit'
import ImagesList from '@/components/Images/List'
import ImageEdit from '@/components/Images/Edit'
import UsersList from '@/components/Users/List'
import UserEdit from '@/components/Users/Edit'
import ParametersList from '@/components/Parameters/List'
import ParameterEdit from '@/components/Parameters/Edit'
import Import from '@/components/Import'
import Changelog from '@/components/Changelog'
import Password from '@/components/Password'
import Reset from '@/components/Reset'
import ResetPassword from '@/components/ResetPassword'

Vue.use(Router)

// const ifNotAuthenticated = (to, from, next) => {
//   if (!store.getters.isAuthenticated) {
//     next()
//     return
//   }
//   next('/events')
// }

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/connexion')
}

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/connexion',
      name: 'Connexion',
      component: Login
    },
    {
      path: '/events',
      name: 'Events',
      component: EventsList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/events/edit',
      name: 'EventEdit',
      component: EventEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/events/import',
      name: 'EventImport',
      component: EventImport,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/events/edit/:id',
      name: 'EventEditExist',
      component: EventEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/events/duplicate/:id',
      name: 'EventDuplicate',
      component: EventDuplicate,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/cities/list',
      name: 'CitiesList',
      component: CitiesList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/city/edit',
      name: 'CityEdit',
      component: CityEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/city/edit/:id',
      name: 'CityEditExist',
      component: CityEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/schools/list',
      name: 'SchoolsList',
      component: SchoolsList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/school/edit',
      name: 'SchoolEdit',
      component: SchoolEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/school/edit/:id',
      name: 'SchoolEditExist',
      component: SchoolEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/establishments/list',
      name: 'EstablishmentsList',
      component: EstablishmentsList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/establishment/edit',
      name: 'EstablishmentEdit',
      component: EstablishmentEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/establishment/edit/:id',
      name: 'EstablishmentEditExist',
      component: EstablishmentEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/types/list',
      name: 'TypesList',
      component: TypesList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/type/edit',
      name: 'TypeEdit',
      component: TypeEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/type/edit/:id',
      name: 'TypeEditExist',
      component: TypeEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/labels/list',
      name: 'LabelsList',
      component: LabelsList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/label/edit',
      name: 'LabelEdit',
      component: LabelEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/label/edit/:id',
      name: 'LabelEditExist',
      component: LabelEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/images/list',
      name: 'ImagesList',
      component: ImagesList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/image/edit',
      name: 'ImageEdit',
      component: ImageEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/image/edit/:id',
      name: 'ImageEditExist',
      component: ImageEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/users/list',
      name: 'UsersList',
      component: UsersList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/user/edit',
      name: 'UserEditExist',
      component: UserEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/user/edit/:id',
      name: 'UserEdit',
      component: UserEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/parameters/list',
      name: 'ParametersList',
      component: ParametersList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/parameter/edit/:id',
      name: 'ParameterEditExist',
      component: ParameterEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/parameter/edit',
      name: 'ParameterEdit',
      component: ParameterEdit,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/import',
      name: 'Import',
      component: Import,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/changelog',
      name: 'Changelog',
      component: Changelog,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/password',
      name: 'Password',
      component: Password,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js